"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IsAddressKey = exports.ADDRESS_KEY_REGEX = void 0;
const class_validator_1 = require("class-validator");
// These are special addresses in places like Baarle-Nassau, Baarle-Hertog, Bad Bentheim and Kranenburg.
// They are in Belgium/Germany, but are connected to the Dutch power grid
// Therefore we need to allow them to call us, even if they aren't valid Dutch postal codes
// ENCLAVE = 2387|2400|2910|0107BL|47559|48455|26899
// If you update this, also check the regex in SanitizeAddressKey
exports.ADDRESS_KEY_REGEX = /^([1-9]\d{3}[A-Z]{2}|(2387|2400|2910|0107BL|47559|48455|26899))_\d{0,50}_[a-zA-Z0-9\!\@\#\$\%\^\&\*\)\(\+\=\.\,\_\-\/\ \\\']{0,50}$/;
/**
 * Checks if the value is a valid address key.
 * Don't forget to combine this decorator with `@IsDefined` and `@SanitizeAddressKey`
 *
 * @example
 * class Example {
 *   @IsAddressKey()
 *   public property: string;
 * }
 *
 * const example = new Example();
 * example.property = '1234AB_12_A'; // is valid
 * example.property = '1234AB_12_ba'; // is valid
 * example.property = '1234AB_12_ba-3'; // is valid, but requires SanitizeAddressKey to be used so it will work in the identification service
 * example.property = '1234AB'; // not valid
 */
const IsAddressKey = () => (target, key) => (0, class_validator_1.Matches)(exports.ADDRESS_KEY_REGEX)(target, key);
exports.IsAddressKey = IsAddressKey;
